































import {Component, Vue, Prop} from 'vue-property-decorator';

@Component({})
export default class ToolbarToogleIconButton extends Vue {
  key = 0;

  btnState = false;

  @Prop({required: true, type: String, default: ''})
  tooltip!: string;

  @Prop({type: Boolean, default: false})
  disabled!: string;

  @Prop({type: Number, default: 0})
  degreeRotateIcon!: number;

  @Prop({default: () => ({})})
  activators!: {};

  click(e: any) {
    this.$emit('click', e);
  }
}
